import { Button, Popover, ActionList, Text } from "@shopify/polaris";
import { Controller } from "react-hook-form";
import { useState, useCallback, useEffect, useRef } from "react";
import Stack from "../../Stack";

const HiddenInput = ({ name, value }) => {
  const prevValue = useRef(value);
  useEffect(() => {
    if (prevValue.current === value) {
      return;
    }
    prevValue.current = value;

    const hiddenInput = document.getElementById(`${name}-hidden`);
    if (hiddenInput) {
      hiddenInput.value = value;
      hiddenInput.dispatchEvent(new Event("change", { bubbles: true }));
    }
  }, [value]);

  return <input id={`${name}-hidden`} type="text" value={value} style={{ display: "none" }} readOnly />;
};

const RHFPopoverSelect = ({ name, control, label, items, disabled, onItemSelect, value, ...other }) => {
  const [popoverActive, setPopoverActive] = useState(false);

  const togglePopoverActive = useCallback(() => {
    setPopoverActive((prev) => !prev);
  }, []);

  return name ? (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <Stack flexDirection="column" spacing="4px">
          <Text variant="bodyMd">{label}</Text>
          <Popover
            active={popoverActive}
            activator={
              <Button onClick={togglePopoverActive} disclosure disabled={disabled}>
                {field.value ? items.find((item) => item.value === field.value)?.content || field.value : `${label}...`}
              </Button>
            }
            autofocusTarget="first-node"
            onClose={togglePopoverActive}
          >
            <ActionList
              actionRole="menuitem"
              items={items.map((item) => ({
                ...item,
                onAction: () => {
                  field.onChange(item.value);
                  item.onAction && item.onAction();
                  onItemSelect && onItemSelect(item);
                  setPopoverActive(false);
                },
                active: item.value === field.value,
              }))}
              {...other}
            />
          </Popover>
          <HiddenInput name={name} value={field.value} />
          {error && <div style={{ color: "red", marginTop: "4px" }}>{error.message}</div>}
        </Stack>
      )}
    />
  ) : (
    <Stack flexDirection="column" spacing="4px">
      <Text variant="bodyMd">{label}</Text>
      <Popover
        active={popoverActive}
        activator={
          <Button onClick={togglePopoverActive} disclosure disabled={disabled}>
            {value ? items.find((item) => item.value === value)?.content || value : `${label}...`}
          </Button>
        }
        autofocusTarget="first-node"
        onClose={togglePopoverActive}
      >
        <ActionList
          actionRole="menuitem"
          items={items.map((item) => ({
            ...item,
            onAction: () => {
              item.onAction && item.onAction();
              onItemSelect && onItemSelect(item);
              setPopoverActive(false);
            },
            active: item.value === value,
          }))}
          {...other}
        />
      </Popover>
    </Stack>
  );
};

export default RHFPopoverSelect;
